"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAvatar = exports.SignInLabel = exports.MobileUserIconButton = exports.DesktopUserIconButton = void 0;
var _mui = require("@ori-ui/mui");
const SignInLabel = exports.SignInLabel = (0, _mui.styled)(_mui.ButtonBase)(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    color: theme.palette.text.primary,
    display: 'block',
    fontSize: '1.4rem',
    fontWeight: theme.typography.fontWeightBold,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    '&:hover, &:focus, &:active': {
      color: theme.palette.grey[600],
      cursor: 'pointer'
    }
  }
}));
const DesktopUserIconButton = exports.DesktopUserIconButton = (0, _mui.styled)(_mui.Button)(({
  theme
}) => ({
  display: 'none',
  fontSize: '1.4rem',
  whiteSpace: 'nowrap',
  lineHeight: '2.1rem',
  minWidth: 'auto',
  fontWeight: theme.typography.fontWeightBold,
  svg: {
    marginLeft: theme.spacing(2)
  },
  [theme.breakpoints.up('md')]: {
    display: 'inline-flex'
  }
}));
const MobileUserIconButton = exports.MobileUserIconButton = (0, _mui.styled)(_mui.ButtonBase)(({
  theme
}) => ({
  fontSize: '3rem',
  color: theme.palette.text.primary,
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
  [theme.breakpoints.up('md')]: {
    display: 'none'
  }
}));
const UserAvatar = exports.UserAvatar = (0, _mui.styled)(_mui.Avatar)(({
  theme
}) => ({
  fontSize: '1rem !important',
  width: 22,
  height: 22,
  backgroundColor: theme.palette.grey[700]
}));
